import { useQuery } from "@apollo/client"
import { useMemo } from "react"
import { BITKUB_GRID_RETURN } from "src/graphql/queries/bitkubExecution"
import { bitkubGridReturnInputType, bitkubGridReturnQuery } from "src/types/bitkub-execution-types"

interface hookProps {
  executionID?:string
}

const useBitkubGridReturnQuery = (props:hookProps) => {
  const { data:Data,...query } = useQuery<bitkubGridReturnQuery>(BITKUB_GRID_RETURN,{
    variables:{
      executionID:props.executionID
    } as bitkubGridReturnInputType,
    skip: props.executionID === ""
  })

  const data = useMemo(()=>{
    if (Data?.bitkubGridReturn?.__typename === "BitkubGridReturn") {
      return Data.bitkubGridReturn
    }
  },[Data])

  const error = useMemo(()=>{
    if (Data?.bitkubGridReturn?.__typename === "Error") {
      return Data.bitkubGridReturn
    }
  },[Data])

  return {
    data,
    error,
    query
  }

}

export default useBitkubGridReturnQuery